import { types } from '../actions/passwordSetup';

const initialState = {
  validatePending: false,
  shouldShow: false,
  validateError: '',
  changePending: false,
  changeError: '',
  changeSuccess: false
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.VALIDATE_DIRECT_INVITE_PENDING:
      return { ...state, validatePending: true, validateError: '' };

    case types.VALIDATE_DIRECT_INVITE_FULFILLED:
      return { ...state, validatePending: false, shouldShow: action.payload };

    case types.VALIDATE_DIRECT_INVITE_REJECTED:
      return { ...state, validatePending: false, shouldShow: false, validateError: action.payload?.message || 'error' };

    case types.CHANGE_DIRECT_INVITE_PASSWORD_PENDING:
      return { ...state, changePending: true, changeError: '', changeSuccess: false };

    case types.CHANGE_DIRECT_INVITE_PASSWORD_FULFILLED:
      return { ...state, changePending: false, changeSuccess: true };

    case types.CHANGE_DIRECT_INVITE_PASSWORD_REJECTED:
      return { ...state, changePending: false, changeError: action.payload?.message || 'error' };

    case types.RESET_PASSWORD_SETUP:
      return initialState;

    default:
      return state;
  }
}
